import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { batchAssignYingshiDeviceStore } from '@/service/yingshi'
import BatchAssignYingshiDeviceStoreForm from './BatchAssignYingshiDeviceStoreForm'

function resolveAssignError (err) {
  if (typeof err === 'string' && err) return err
  return (
    err?.response?.data?.msg ||
    err?.response?.data?.message ||
    err?.msg ||
    err?.message ||
    '分配失败'
  )
}

function parseTargetStoreId (raw) {
  if (raw == null || raw === '') return null
  const n = Number(raw)
  if (!Number.isFinite(n) || n === 0) return null
  return n
}

/**
 * baseProps 契约：
 * - deviceIds：待分配设备 id 列表
 * - storeOptions：门店下拉 [{ id, value }, ...]
 */
class BatchAssignYingshiDeviceStoreModal extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    width: PropTypes.number,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    children: PropTypes.node,
    disabledModal: PropTypes.bool
  }

  static defaultProps = {
    title: '分配店铺',
    width: 480,
    baseProps: {},
    disabledModal: false
  }

  handleOk = async (form) => {
    const { baseProps, onSuccess } = this.props
    const { deviceIds = [] } = baseProps || {}
    const ids = (Array.isArray(deviceIds) ? deviceIds : [])
      .map((id) => {
        const n = Number(id)
        return Number.isFinite(n) ? n : id
      })
      .filter((id) => id != null && id !== '')
    if (ids.length === 0) {
      message.error('请先勾选要分配的设备')
      throw new Error('请先勾选要分配的设备')
    }
    try {
      const fields = await form.current.validateFields()
      const storeId = parseTargetStoreId(fields.storeId)
      if (storeId == null) {
        message.error('请选择目标店铺')
        throw new Error('请选择目标店铺')
      }
      await batchAssignYingshiDeviceStore({ ids, storeId })
      message.success(`已将 ${ids.length} 台设备分配到目标店铺`)
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      if (err?.errorFields) throw err
      message.error(resolveAssignError(err))
      throw err
    }
  }

  render () {
    const { children, baseProps, title, width, disabledModal } = this.props
    const bp = baseProps || {}
    const formKey = Array.isArray(bp.deviceIds) ? bp.deviceIds.join(',') : 'empty'
    return (
      <WrappedModal
        children={children}
        baseComponent={<BatchAssignYingshiDeviceStoreForm key={formKey} baseProps={bp} />}
        baseProps={{ ...bp }}
        title={title}
        width={width}
        okText="确认分配"
        disabledModal={disabledModal}
        onOk={this.handleOk}
      />
    )
  }
}

export default BatchAssignYingshiDeviceStoreModal
